import { z } from 'zod';

/** Time on one page or one section of the demo, in seconds. */
const timeSpent = z.object({ name: z.string(), seconds: z.number() });

/** One person's use of their private copy, as the template's Demo insights page shows it. */
export const demoPersonInsightsSchema = z.object({
  copyId: z.string(),
  email: z.string(),
  name: z.string().nullable(),
  signedUp: z.boolean(),
  firstSeenAt: z.number().nullable(),
  lastSeenAt: z.number().nullable(),
  sessions: z.number(),
  seconds: z.number(),
  sections: z.array(timeSpent),
  pages: z.array(timeSpent),
  /** The page each visit ended on, newest first. */
  leftFrom: z.array(z.object({ at: z.number(), page: z.string() })),
  questions: z.array(z.object({ at: z.number(), text: z.string() })),
  feedback: z.array(z.object({ at: z.number(), page: z.string(), text: z.string() })),
  changes: z.number(),
  problems: z.array(z.object({ at: z.number(), kind: z.string(), action: z.string(), status: z.number().nullable(), detail: z.string().nullable() })),
});
export type DemoPersonInsights = z.infer<typeof demoPersonInsightsSchema>;

/** What Convex answers before the API adds each person's questions. */
export const demoInsightsWithoutQuestionsSchema = z.object({
  people: z.array(demoPersonInsightsSchema.omit({ questions: true })),
  sections: z.array(timeSpent),
  leftFrom: z.array(z.object({ page: z.string(), visits: z.number() })),
});
export const demoQuestionsSchema = demoPersonInsightsSchema.shape.questions;

export const demoInsightsSchema = z.object({
  people: z.array(demoPersonInsightsSchema),
  /** Everyone together: time per section, and the pages visits most often ended on. */
  sections: z.array(timeSpent),
  leftFrom: z.array(z.object({ page: z.string(), visits: z.number() })),
});
export type DemoInsights = z.infer<typeof demoInsightsSchema>;

/** What the web sends while a page of a private copy is on screen. */
export const demoViewBeatSchema = z.object({ page: z.string().trim().min(1).max(300), visitId: z.string().min(8).max(64), seconds: z.number().min(0).max(120) });
export const demoFeedbackSchema = z.object({ page: z.string().trim().min(1).max(300), text: z.string().trim().min(1).max(2_000) });
